import type { RootState } from "../../store/store";
import { createSelector } from "@reduxjs/toolkit";
import { portalIdentity } from "./portalIdentity";

export const selectPortalCredentials = (state: RootState) => state.auth.credentials;
export const selectPortalIdentity = createSelector(selectPortalCredentials, (credentials) =>
  portalIdentity.read(credentials),
);
export const selectPortalAccountScope = createSelector(selectPortalCredentials, (credentials) =>
  portalIdentity.scope(credentials),
);
